import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppLayout } from "@/components/layout/app-layout";
import { useAuth } from "@/hooks/use-auth";
import { InvitationsPage } from "@/pages/invitations";
import { LoginPage } from "@/pages/login";
import { OrganizationsPage } from "@/pages/organizations";
import { OverviewPage } from "@/pages/overview";
import { UsagePage } from "@/pages/usage";
import { UsersPage } from "@/pages/users";

export function AppRoutes() {
  const { isSignedIn } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        {!isSignedIn ? (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <>
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<OverviewPage />} />
              <Route path="/organizations" element={<OrganizationsPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/usage" element={<UsagePage />} />
              <Route path="/invitations" element={<InvitationsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}
